export function getPastedTextFileName(attachmentCount) {
    return attachmentCount ? `paste-${attachmentCount + 1}.txt` : 'paste.txt';
}
//# sourceMappingURL=getPastedTextFileName.js.map